import type { Option } from '@autobid/strapi-integration/typescript/webapi/Dictionary'
import { useDictionary } from '@autobid/ui/composables/useDictionary'
import { computed } from 'vue'
import { useOtherFeatures } from './useOtherFeatures'

export function useOtherFeaturesToDisplay(type: 'auction' | 'searchList') {
  const { otherFeatures } = useOtherFeatures(type)
  const { dictionary } = useDictionary({ type: 'auctions' })

  const otherFeaturesToDisplay = computed(() => {
    if (!dictionary.value) {
      return []
    }

    const { e174, e223 } = otherFeatures.value
    const res: Option[] = []

    if (e174) {
      res.push({ ...dictionary.value.e174, id: `carList-e174=1` })
    }

    if (e223 && Object.keys(e223).length > 0) {
      const KEY = 'e223'
      const e223Dictionary = dictionary.value[KEY]

      if (e223Dictionary.options?.length) {
        res.push(
          ...e223Dictionary.options
            .filter(item => e223[item.id.toString()])
            .map(item => ({ ...item, id: `carList-${KEY}=${item.id}` })),
        )
      }
    }

    return otherFeatures.value.atLeastOneExists ? res : []
  })

  return {
    otherFeaturesToDisplay,
  }
}
